import {IComponentController, IComponentOptions} from "angular";

export enum ImportType {
    Funded = 'FUNDED',
    Canceled = 'CANCELED',
    PreApproved = 'PRE_APPROVED',
}

export class ImportLogComponent implements IComponentController {

    public static instance: IComponentOptions = {
        bindings: {
            selectedImportTypes: '='
        },
        template: require('./import-type-picker.html'),
        controller: ImportLogComponent
    };

    selectedImportTypes: String[];
    importTypes: ImportType[] = Object.values(ImportType)

    updateTypes = (selectedBranchesNames: String[]) => {
        this.selectedImportTypes = selectedBranchesNames;
    };






}